import { ObjectElement } from "../ObjectElement";
import { PropertyChangingEvent } from "../event/PropertyChangingEvent";
import { getProxyTarget } from "../common";
/**
 * Input Element
 */
export class InputElement extends ObjectElement {
    /**
     * Constructor
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    constructor(htmlElement, bindData, context) {
        super(htmlElement, bindData, context);
        this.readonly = false;
        this.disabled = false;
        // Adds change event listener
        this.getHtmlElement().addEventListener('change', e => {
            let element = this.getHtmlElement();
            let data = getProxyTarget(this.getBindData());
            let propertyChangingEvent = new PropertyChangingEvent(element, data, this.getProperty(), this.getValue(), this.getIndex());
            this.notifyObservers(propertyChangingEvent);
        }, true);
        // turn off autocomplete
        this.getHtmlElement().setAttribute('autocomplete', 'off');
    }
    /**
     * Sets element value
     * @param value element value
     */
    setValue(value) {
        if (value != null) {
            value = this.getFormat() ? this.getFormat().format(value) : value;
        }
        else {
            value = '';
        }
        this.getHtmlElement().value = value;
    }
    /**
     * Gets element value
     */
    getValue() {
        let value = this.getHtmlElement().value;
        if (value) {
            value = this.getFormat() ? this.getFormat().parse(value) : value;
        }
        else {
            value = null;
        }
        return value;
    }
    /**
     * Sets readonly
     * @param readonly readonly or not
     */
    setReadonly(readonly) {
        this.readonly = readonly;
        this.getHtmlElement().readOnly = readonly;
        // exceptional type (mobile browser does not support readonly)
        let type = this.getHtmlElement().getAttribute('type');
        if (['datetime-local', 'date', 'time'].includes(type)) {
            if (this.readonly || this.disabled) {
                this.getHtmlElement().setAttribute('disabled', 'disabled');
            }
        }
    }
    /**
     * Sets disabled
     * @param disabled disabled or not
     */
    setDisabled(disabled) {
        this.disabled = disabled;
        if (disabled) {
            this.getHtmlElement().setAttribute('disabled', 'disabled');
        }
        else {
            this.getHtmlElement().removeAttribute('disabled');
        }
        // exceptional type (mobile browser does not support readonly)
        let type = this.getHtmlElement().getAttribute('type');
        if (['datetime-local', 'date', 'time'].includes(type)) {
            if (this.disabled || this.readonly) {
                this.getHtmlElement().setAttribute('disabled', 'disabled');
            }
        }
    }
    /**
     * Focus element
     */
    focus() {
        this.getHtmlElement().focus();
        return true;
    }
}
//# sourceMappingURL=InputElement.js.map